// 在地图投影后的屏幕坐标上生成弧线，保持缩放、旋转时端点与地点一致。
export function flightCurve(start, end) {
    const dx = end.x - start.x
    const dy = end.y - start.y
    const distance = Math.hypot(dx, dy)
    // 重合或被点位覆盖的短距离只显示地点，不制造虚假的飞行方向。
    if (!Number.isFinite(distance) || distance < 48) return null
    const bend = Math.min(distance * .22, 160)
    return { start, end, control: { x: (start.x + end.x) / 2 - dy / distance * bend, y: (start.y + end.y) / 2 + dx / distance * bend } }
}

export function flightPoint({ start, control, end }, t) {
    const s = 1 - t
    return { x: s * s * start.x + 2 * s * t * control.x + t * t * end.x, y: s * s * start.y + 2 * s * t * control.y + t * t * end.y }
}

export function flightAngle({ start, control, end }, t) {
    return Math.atan2((1 - t) * (control.y - start.y) + t * (end.y - control.y), (1 - t) * (control.x - start.x) + t * (end.x - control.x))
}

export function hitFlight(curve, point) {
    // 给端点图标留出点击范围；曲线命中使用线段距离，长线也不会漏点。
    if (Math.hypot(point.x - curve.start.x, point.y - curve.start.y) < 42
        || Math.hypot(point.x - curve.end.x, point.y - curve.end.y) < 42) return false
    let previous = curve.start
    for (let i = 1; i <= 48; i += 1) {
        const next = flightPoint(curve, i / 48)
        const dx = next.x - previous.x, dy = next.y - previous.y
        const t = Math.max(0, Math.min(1, ((point.x - previous.x) * dx + (point.y - previous.y) * dy) / (dx * dx + dy * dy)))
        if (Math.hypot(point.x - previous.x - t * dx, point.y - previous.y - t * dy) < 8) return true
        previous = next
    }
    return false
}
